module.exports = __webpack_public_path__ + "img/check-cupo-modal.e083b9e0.svg";